import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import BalanceIcon from '@mui/icons-material/Balance';
import { legalmenteForegroundOnPage } from '../legalmenteReadableText';

const Metrics = () => {
  const theme = useTheme();
  const headingColor = legalmenteForegroundOnPage(theme);
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) return;
    setViewPortEntered(isVisible);
  };

  const iconProps = { sx: { fontSize: 40, color: headingColor } };

  const metricsData = [
    {
      title: 30000,
      label: 'Visitas mensuales en la plataforma TNO',
      subtitle: 'Comunidad activa y contenido On-Demand (referencia media kit).',
      suffix: '+',
      icon: <LanguageIcon {...iconProps} />,
    },
    {
      title: 1,
      label: 'Emisión en vivo semanal',
      subtitle: 'Lunes 12:00 PM — primera radio visual de Venezuela.',
      suffix: '',
      icon: <LiveTvIcon {...iconProps} />,
    },
    {
      title: 11,
      label: 'Años de innovación TNO',
      subtitle: 'Respaldo institucional y multiplataforma.',
      suffix: '+',
      icon: <OndemandVideoIcon {...iconProps} />,
    },
    {
      title: 100,
      label: 'Brand safe + ROI editorial',
      subtitle: 'Asociación con autoridad legal, alcance digital y prestigio de marca.',
      suffix: '%',
      icon: <BalanceIcon {...iconProps} />,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium', color: headingColor }}
          gutterBottom
          align="center"
        >
          Alcance
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          align="center"
          gutterBottom
          sx={{ color: headingColor }}
        >
          Los números de Legalmente en Familia
        </Box>
        <Typography variant="h6" align="center" color="textSecondary" sx={{ mb: 4 }}>
          Tu mensaje viaja en vivo, queda en la bóveda digital y acompaña a la audiencia cada vez que repite el
          episodio.
        </Typography>
      </Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 8 }}>
        <Grid container spacing={2}>
          {metricsData.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={3}>
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={2}>
                {item.icon}
              </Box>
              <Typography variant="h3" align="center" gutterBottom>
                <Box fontWeight={600}>
                  <VisibilitySensor onChange={(isVisible) => setViewPortVisibility(isVisible)} delayedCall>
                    <CountUp redraw={false} end={viewPortEntered ? item.title : 0} start={0} suffix={item.suffix} />
                  </VisibilitySensor>
                </Box>
              </Typography>
              <Typography align="center" variant="h6" gutterBottom>
                {item.label}
              </Typography>
              <Typography color="text.secondary" align="center" component="p">
                {item.subtitle}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Metrics;
